export { default } from './ValuesList';
